import { JsonProperty } from '../../utils/json-typescript-mapper';
import { BaseModel } from '../../models/base.model';

export class CellPhoneUpdateDialog extends BaseModel<CellPhoneUpdateDialog> {

    @JsonProperty('PhoneNumber')
    phoneNumber: string;

    constructor(properties?: Partial<CellPhoneUpdateDialog>) {
        super({
            phoneNumber: undefined
        }, properties);
    }
}
